module.exports = __webpack_public_path__ + "img/ico_bell--bl.bf15531e.svg";